import React from 'react';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';
import { GoalWeightValidation } from './useGoalWeightValidation';
import './GoalWeightValidationBanner.css';

const i18prefix = 'performanceReview.goals2';

type Props = {
  goalWeightValidation: GoalWeightValidation;
};

export const GoalWeightValidationBanner: React.FC<
  React.PropsWithChildren<Props>
> = ({ goalWeightValidation }) => {
  const { t } = useTranslation();
  const { valid, errors, employeeValidations } = goalWeightValidation;

  if (valid) {
    return null;
  }

  const renderTooltipContent = () => {
    if (employeeValidations.length > 0) {
      return (
        <div className="text-start">
          {employeeValidations.map((ev) => (
            <div key={ev.employeeId} className="mb-2">
              <div className="fw-bold">{ev.employeeName}</div>
              <ul className="list-unstyled mb-0">
                {ev.errors.map((error, index) => (
                  <li key={index}>• {error.errorMessage}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      );
    }
    return (
      <ul className="list-unstyled text-start mb-0">
        {errors.map((error, index) => (
          <li key={index}>• {error.errorMessage}</li>
        ))}
      </ul>
    );
  };

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip
          id="goal-weight-validation-tooltip"
          className="goal-weight-validation-tooltip">
          {renderTooltipContent()}
        </Tooltip>
      }>
      <span className="d-inline-flex align-items-center text-warning text-nowrap">
        <FlairIcon icon="alert-triangle-outline" size="sm" className="me-2" />
        {t(`${i18prefix}.weightValidation.attentionRequired`)}
      </span>
    </OverlayTrigger>
  );
};
